﻿function filterFaqs(event) {
    event.preventDefault();
    const search = $(event.currentTarget).val();
    $("[data-faq-name] a").each(function (index, element) {
        const link = $(element);
        const faqName = link.text();
        if (faqName.toLowerCase().indexOf(search.toLowerCase()) > -1) {
            link.parents("[data-faq-name]").removeClass('d-none');
        } else {
            link.parents("[data-faq-name]").addClass('d-none');
        }
    });
    $("[data-faq-category]").each(function (index, element) {
        const category = $(element);
        const visibleFaqs = category.find("[data-faq-name]:not(.d-none)");
        if (visibleFaqs.length > 0) {
            category.removeClass('d-none');
        } else {
            category.addClass('d-none');
        }
    });
}

export function setupFaqSearch() {
    $(document).on("keyup", "[data-faq-search]", filterFaqs);
}
